import { store } from '@redux/store';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import uiStateSlice from 'layout/redux/uiStateSlice';
import { filter, fromEvent, map } from 'rxjs';

const footerLinks = document.querySelector('[data-footer-links]');
const eventsMapper = new Map();

// Quick Links
eventsMapper.set('footer_55_plus', new GoogleAnalyticsEvent('Site Links', 'Footer', 'New 55+ Communities'));
eventsMapper.set('footer_condos_townhouses', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'Search New Condos'));
eventsMapper.set('footer_custom_homes_center', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Custom Home Buyers'));
eventsMapper.set('footer_first_time_homebuyers',
    new GoogleAnalyticsEvent('Site Links', 'Footer', 'New First Time Buyers Communities'));
eventsMapper.set('footer_luxury_homes', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'Search Luxury Homes'));
eventsMapper.set('footer_modular_homes', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'Search Modular Homes'));
// Resources
eventsMapper.set('footer_learning_center', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'Learning Center'));
eventsMapper.set('footer_ratings_and_reviews',
    new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'TrustBuilder Ratings Review'));
eventsMapper.set('footer_real_estate_professionals',
    new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'New Home Source Professional'));
eventsMapper.set('footer_casas_nuevas', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'Casas Nuevas'));
eventsMapper.set('footer_start_fresh_buy_new',
    new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'StartFreshBuyNew'));
// Helpful Links
eventsMapper.set('footer_about_us', new GoogleAnalyticsEvent('Site Links', 'Footer', 'About us'));
eventsMapper.set('footer_contact_us', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Contact us'));
eventsMapper.set('footer_list_your_homes', new GoogleAnalyticsEvent('Outbound Links', 'Footer', 'List Your Homes'));
eventsMapper.set('footer_unsubscribe', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Unsubscribe'));
eventsMapper.set('footer_accessibility', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Accessibility statement'));
eventsMapper.set('footer_terms_of_use', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Terms of use'));
eventsMapper.set('footer_privacy_policy', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Privacy policy'));
eventsMapper.set('footer_site_help', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Site Help'));
eventsMapper.set('footer_do_not_sell_my_info', new GoogleAnalyticsEvent('Site Links', 'Footer', 'Do Not Sell My Info'));
// Footer Social Site Links
eventsMapper.set('footer_facebook_link', new GoogleAnalyticsEvent('Outbound Links', 'Social', 'Facebook'));
eventsMapper.set('footer_pinterest_link', new GoogleAnalyticsEvent('Outbound Links', 'Social', 'Pinterest'));
eventsMapper.set('footer_twitter_link', new GoogleAnalyticsEvent('Outbound Links', 'Social', 'Twitter'));
eventsMapper.set('footer_youtube_link', new GoogleAnalyticsEvent('Outbound Links', 'Social', 'Ytube'));
eventsMapper.set('footer_instagram_link', new GoogleAnalyticsEvent('Outbound Links', 'Social', 'Instagram'));

function trackGAEvent(key) {
    const googleAnalyticsDTO = eventsMapper.get(key);
    store.dispatch(uiStateSlice.actions.trackUserEvent({googleAnalyticsDTO}))
}

fromEvent(footerLinks, 'click')
    .pipe(
        map((element)=> element.target.closest('[data-footer-link]')),
        filter(Boolean),
        map((element)=> element.dataset.footerLink), 
        filter(Boolean)
    )
    .subscribe(trackGAEvent);

